













































































































import { Vue, Component, Prop } from "vue-property-decorator";
import {
  FeatureType,
  Features,
  Alignment,
  Alignments,
  Orientation,
  Orientations,
  FeaturePosition,
  FeaturePositions,
  FeatureShape,
  FeatureShapes
} from "../../types/TrialPitFeatures";

export interface TrialPitFeatureModel {
  type: FeatureType;
  label: string;
  alignment: Alignment;
  orientation: Orientation;
  position: FeaturePosition;
  shape: FeatureShape;
  y1: number;
  y2: number;
  x1: number;
  x2: number;
  depth: number;
  width: number;
  height: number;
}

@Component({})
export default class TrialPitFeature extends Vue {
  @Prop({
    default: () => ({
      type: "object",
      label: "",
      alignment: "center",
      orientation: "horizontal",
      position: "parallel",
      shape: "circle",
      y1: 0,
      y2: 0,
      x1: 0,
      x2: 0,
      depth: 0,
      width: 0,
      height: 0
    })
  })
  private feature!: TrialPitFeatureModel;

  private featureTypes = Features;
  private alignments = Alignments;
  private orientations = Orientations;
  private positions = FeaturePositions;
  private shapes = FeatureShapes;

  private showField(
    fieldName:
      | "Position"
      | "Shape"
      | "X1"
      | "X2"
      | "Y1"
      | "Y2"
      | "Depth"
      | "Width"
      | "Height"
  ) {
    switch (fieldName) {
      case "Position":
        return this.feature.type === "pipe";
      case "Shape":
        return this.feature.type === "object";
      case "X1":
        return (
          ["object", "pipe", "hLine", "vLine", "label"].indexOf(
            this.feature.type
          ) !== -1
        );
      case "X2":
        return this.feature.type === "pipe";
      case "Y1":
        return ["pipe", "hLine", "vLine"].indexOf(this.feature.type) !== -1;
      case "Y2":
        return this.feature.type === "pipe";
      case "Depth":
        return (
          ["object", "waterLevel", "label"].indexOf(this.feature.type) !== -1
        );
      case "Width":
        return ["pipe", "object", "hLine"].indexOf(this.feature.type) !== -1;
      case "Height":
        return (
          (this.feature.type === "object" &&
            this.feature.shape === "rectangle") ||
          this.feature.type === "vLine"
        );
      default:
        return false;
    }
  }

  private featureChanged() {
    this.$emit("featureChanged");
  }
}
